import React, { useCallback, useEffect, useMemo, useState } from "react";
import TableComponent from "../../Global Functions/tableComponents";
import { columnsNewsBrand } from "../../Global Functions/columnsAntd";
import { getNewsBrandList } from "../../Redux/Actions/newsBrandAction";
import DateRangePopup from "../../Utils/dateFilterPopup";
import { useDispatch, useSelector } from "react-redux";

const DEBOUNCE_DELAY = 500;

const ListNewsBrand = () => {
  const dispatch = useDispatch();

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });

  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);
  const [dateRange, setDateRange] = useState({ start: null, end: null });

  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');


  const { newsBrands, loading } = useSelector((state) => state.newsBrand);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchQuery.trim());
      setPagination((p) => ({ ...p, current: 1 }));
    }, DEBOUNCE_DELAY);

    return () => clearTimeout(timer);
  }, [searchQuery]);

  const requestPayload = useMemo(() => {
    const payload = {
      page: pagination.current,
      limit: pagination.pageSize,
      filter: debouncedSearch,
    };

    if (dateRange.start) {
      payload.start_date = dateRange.start.format("YYYY-MM-DD");
    }

    if (dateRange.end) {
      payload.end_date = dateRange.end.format("YYYY-MM-DD");
    }

    return payload;
  }, [
    pagination.current,
    pagination.pageSize,
    debouncedSearch,
    dateRange,
  ]);

  useEffect(() => {
    dispatch(getNewsBrandList(requestPayload));
  }, [dispatch, requestPayload]);

  useEffect(() => {
    if (newsBrands?.total !== pagination.total) {
      setPagination((p) => ({
        ...p,
        total: newsBrands?.total || 0,
      }));
    }
  }, [newsBrands?.total, pagination.total]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchQuery]);

  const handleDateRangeApply = (start, end) => {
    if (start === null && end === null) {
      setDateRange({ start: null, end: null });
    } else {
      setDateRange({ start, end });
    }
    setIsDatePopupVisible(false);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };


  const handleTableChange = useCallback((pager) => {
    setPagination((p) => ({
      ...p,
      current: pager.current,
      pageSize: pager.pageSize,
    }));
  }, []);

  const tableData = useMemo(
    () => (Array.isArray(newsBrands?.data) ? newsBrands.data : []),
    [newsBrands?.data]
  );

  return (
    <>
      <TableComponent
        columns={columnsNewsBrand(canEdit)}
        dataSource={tableData}
        h3heading="Featured/Associated Brands"
        setState={setSearchQuery}
        onChange={handleTableChange}
        pagination={pagination}
        onCalendarClick={() => setIsDatePopupVisible(true)}
        buttonhead2={canAdd ? "Add Brand" : null}
        navigateTo2={canAdd ? "/fa_brands/add" : null}
        loading={loading}
      />

      <DateRangePopup
        visible={isDatePopupVisible}
        initialStart={dateRange.start}
        initialEnd={dateRange.end}
        onCancel={() => setIsDatePopupVisible(false)}
        onOk={handleDateRangeApply}
      />
    </>
  );
};

export default ListNewsBrand;
